export default __webpack_public_path__ + "static/media/banner-8.50ccb8b7.jpg";